<template>
    <div class="caseDealStatus">
      <ul
        ref="stageFatherBox"
        class="clearfix"
        :style="processConfig.processContent"
      >
        <li
          v-for="(item, index) in stageList"
          id="stageBox"
          :key="index"
          ref="stageBox"
          :style="processConfig.stageBox"
        >{{ item.label }}</li>
      </ul>
    </div>
  </template>
  
  <script>
  import mixin from '@/mixins/mixin'
  export default {
    name: 'EXStageBox',
    mixins: [mixin],
    props: {
      dicCode: {
        type: String,
        default: ''
      },
      nowStage: {
        type: String,
        default: ''
      },
      processConfig: {
        type: Object,
        default: () => {
          return {
            arrowWidth: '100%',
            arrowMargin: '0.06rem 0.005rem',
            processContent: {
              width: '89%'
            },
            stageBox: {
              width: 'auto',       //根据文本内容自适应宽度
              height: '0.63rem',
              fontSize: '0.16rem',
              lineHeight: '0.63rem',
              paddingRight: '0.05rem',
              paddingLeft: '0.05rem',
              whiteSpace: 'nowrap'  //保证文本在同一行内显示
            }
          }
        }
      }
    },
    data() {
      return {
        stageList: [],
        curNowStage: ''
      }
    },
    watch: {
      nowStage: function(val,old) {
        if(val != old){
          this.curNowStage = val
          this.getStageInfo()
        }
      }
    },
    mounted() {
      if(this.curNowStage != ''){
        this.getStageInfo()
      }
    },
    methods: {
      async getStageInfo() {
        if(this.dicCode && this.dicCode.trim().length > 0){
            const list  = await this.mixFeignDictDataList(this.dicCode)
            this.stageList = list
        }
        this.$nextTick(() => {
          if(this.$refs.stageBox){
            const stageBoxLen = this.$refs.stageBox.length
            for (let i = 0; i < stageBoxLen; i++) {
              if (i !== stageBoxLen - 1) {
                const li = document.createElement('li')
                li.className = 'stageArrow'
                li.innerHTML =
                  '<div style="width:' +
                  this.processConfig.arrowWidth +
                  ' ;margin:' +
                  this.processConfig.arrowMargin +
                  '"><img style="width:' +
                  this.processConfig.arrowWidth +
                  '" src="static/img/stage/stageArrowGrey.png" alt=""></div>'
    
                this.$refs.stageFatherBox.insertBefore(
                  li,
                  this.$refs.stageBox[i].nextSibling
                )
              }
              this.$refs.stageBox[i].style.background =
                'url("static/img/stage/stageGrey.png") no-repeat'
              this.$refs.stageBox[i].style.backgroundSize = '100% 100%'
              if (Number(this.stageList[i].value) <= Number(this.curNowStage)) {
                if (i === stageBoxLen - 1) {
                  this.$refs.stageBox[i].style.background =
                  'url("static/img/stage/stagebule.png") no-repeat'
                  this.$refs.stageBox[i].style.backgroundSize = '100% 100%'
                } else {
                  this.$refs.stageBox[i].style.background =
                  'url("static/img/stage/stagegreen.png") no-repeat'
                  this.$refs.stageBox[i].style.backgroundSize = '100% 100%'
                }
    
                if (i !== 0) {
                  this.$refs.stageBox[i - 1].style.background =
                    'url("static/img/stage/stagebule.png") no-repeat'
                  this.$refs.stageBox[i - 1].style.backgroundSize = '100% 100%'
                  if (
                    this.$refs.stageBox[i].previousSibling.className.indexOf(
                      'stageArrow'
                    ) !== -1
                  ) {
                    this.$refs.stageBox[i].previousSibling.innerHTML =
                      '<div style="width:' +
                      this.processConfig.arrowWidth +
                      ' ;margin:' +
                      this.processConfig.arrowMargin +
                      '"><img style="width:' +
                      this.processConfig.arrowWidth +
                      '" src="static/img/stage/stageArrowBule.png" alt=""></div>'
                  }
                  if (
                    this.$route.query.module != 'caseSelfHandle' &&
                    Number(this.curNowStage) == 8
                  ) {
                    this.$refs.stageBox[7].style.background =
                      'url("static/img/stage/stagebule.png") no-repeat'
                    this.$refs.stageBox[7].style.backgroundSize = '100% 100%'
                  }
                }
              }
            }
          }
        })
  
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .caseDealStatus {
    text-align: center;
    ul {
      width: 78%;
      display: flex;
      margin: 0.1rem auto;
  
      /deep/ .stageArrow {
        margin: 0.18rem 0.005rem;
      }
      .stageArrow {
        img {
          width: 100%;
        }
      }
      li {
        float: left;
        width: 1.5rem;
        height: 0.45rem;
        line-height: 0.45rem;
        text-align: center;
        margin: 0 0.05rem;
        &:nth-of-type(odd) {
          font-size: 0.14rem;
          color: #fff;
          // border-radius: 50%;
          // background: 'url("../../../../assets/images/stageGrey.png") no-repeat';
          background-size: 100% 100%;
        }
        img {
          width: 100%;
          vertical-align: middle;
        }
      }
      li.isActive {
        background: rgb(30, 138, 124);
      }
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/EXStageBox/index.vue